import CloudUploadRounded from '@material-ui/icons/CloudUploadRounded';
import { Fragment } from 'react';
import './ImageUploader.scss';

const ImageUploader = (props: {
  img?: File;
  onImgChanged: (img: File) => void;
}) => {
  return (
    <Fragment>
      <div className="image-uploader" onClick={ () => {
        (document.getElementById('image-uploader-input') as HTMLInputElement).click();
      } }>
        { !!props.img ? (
          <img src={ URL.createObjectURL(props.img) } alt="Borítókép" />
        ) : (
          <span>
            <CloudUploadRounded color="inherit" />
            <p>Borítókép feltöltése</p>
          </span>
        ) }
      </div>
      <input type="file" accept="image/*" id="image-uploader-input" style={ {
        display: 'none'
      } } onChange={ (event) => {
        props.onImgChanged(event.currentTarget.files![ 0 ]);
      } } />
    </Fragment>
  );
};

export default ImageUploader;
